import { View, Text, StyleSheet, TouchableOpacity, Image } from "react-native";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fatherProfile, motherProfile } from "../../imports";
import { useNavigation } from "@react-navigation/native";

export default function HeaderProfileIcon(props) {
  const navigation = useNavigation();
  const header = useSelector((store) => store.header);
  const user = useSelector((store) => store.user);
 return (
    <TouchableOpacity
      onPress={() =>
        props.notOpenDrawer !== undefined ? null : navigation.openDrawer()
      }
      style={[
        styles.container,
        {
          backgroundColor:
            user.information.TOFM !== "father" ? "yellow" : "#18D39B",
        },
      ]}
    >
      <Image
        style={styles.image}
        source={
          user.information.TOFM !== "father" ? motherProfile : fatherProfile
        }
      />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 50,
    height: 50,
    borderRadius: 50,
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    width: 50,
    height: 50,
  },
});
